export default __webpack_public_path__ + "static/media/D7Mono.cea5d881.woff";